import { render, staticRenderFns } from "./page-grid.vue?vue&type=template&id=2a130f5c"
import script from "./page-grid.vue?vue&type=script&lang=js"
export * from "./page-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports